module.exports = __webpack_public_path__ + "static/media/sentiment_neutral.1096c845.svg";